import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaRoad, FaClock, FaRupeeSign, FaArrowRight, FaPhoneAlt, FaWhatsapp, FaPlane } from 'react-icons/fa';
import { GiCarSeat, GiGearStick } from 'react-icons/gi';
import { MdLocalGasStation } from 'react-icons/md';
import ertigaImage from '../../assets/front-left-side-47.avif';
import kiaCarensImage from '../../assets/20250808114824_Kia_Carens_Sparkling_Silver[1].avif';
import crystaImage from '../../assets/images.jpg';
import hycrossImage from '../../assets/hycross.avif';
import fortunerImage from '../../assets/fortunes.avif';
import { buildLandingBookingState, loadLandingPageVehicles } from './vehicleLandingPageData';

const suvImageMap = {
  ertiga: ertigaImage,
  crysta: crystaImage,
  hycross: hycrossImage,
  fortuner: fortunerImage,
  default: ertigaImage,
};

const SuvRentalPage = () => {
  // Tab state: 'local', 'outstation', or 'airport'
  const [activeTab, setActiveTab] = useState('local');
  const [apiSuvList, setApiSuvList] = useState({ airport: [], outstation: [], local: [] });
  const [isLoadingApiVehicles, setIsLoadingApiVehicles] = useState(true);
  const navigate = useNavigate();
  
  // SUV Data
  const suvList = {
    local: [
      {
        id: 'ertiga',
        name: 'SUV Ertiga',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 2900,
        priceLabel: 'per day',
        includes: '8 hours | 80 km',
        extraKm: 17,
        extraHour: 170,
        image: ertigaImage,
        seats: '7 Seater',
        fuel: 'Diesel',
        transmission: 'Manual'
      },
      {
        id: 'innova',
        name: 'Innova Crysta',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 3500,
        priceLabel: 'per day',
        includes: '8 hours | 80 km',
        extraKm: 22,
        extraHour: 220,
        image: 'https://cdn-s3.autocarindia.com/legacy/cdni/ExtraImages/20220105033033_innova_crysta.jpg?w=728&q=75',
        seats: '7 Seater',
        fuel: 'Diesel',
        transmission: 'Manual'
      },
      {
        id: 'hycross',
        name: 'Hycross Hybrid',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 4000,
        priceLabel: 'per day',
        includes: '8 hours | 80 km',
        extraKm: 25,
        extraHour: 250,
        image: 'https://imgd.aeplcdn.com/1200x900/n/cw/ec/136051/toyota-innova-hycross-left-front-three-quarter0.jpeg?isig=0&wm=0',
        seats: '7 Seater',
        fuel: 'Hybrid',
        transmission: 'Automatic'
      }
    ],
    outstation: [
      {
        id: 'ertiga-out',
        name: 'SUV Ertiga / Rumion',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 16,
        priceLabel: 'per km',
        includes: '300 km/day included',
        driverBeta: 400,
        minKms: 300,
        image: ertigaImage,
        seats: '7 Seater',
        fuel: 'Diesel',
        transmission: 'Manual'
      },
      {
        id: 'innova6-out',
        name: 'Innova Crysta 6+1',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 22,
        priceLabel: 'per km',
        includes: '300 km/day included',
        driverBeta: 500,
        minKms: 300,
        image: 'https://img.gaadibazaar.in/new-vehicle-images/1703330/conversions/08caca25-b714-472a-870c-1963770dff08-vdp.webp',
        seats: '6+1 Seater',
        fuel: 'Diesel',
        transmission: 'Manual'
      },
      {
        id: 'innova7-out',
        name: 'Innova Crysta 7+1',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 19,
        priceLabel: 'per km',
        includes: '300 km/day included',
        driverBeta: 500,
        minKms: 300,
        image: 'https://stimg.cardekho.com/images/carexteriorimages/930x620/Toyota/Innova-Crysta/9608/1755846139274/front-left-side-47.jpg',
        seats: '7+1 Seater',
        fuel: 'Diesel',
        transmission: 'Manual'
      },
      {
        id: 'hycross-out',
        name: 'HyCross Hybrid 7+1',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: 23,
        priceLabel: 'per km',
        includes: '300 km/day included',
        driverBeta: 500,
        minKms: 300,
        image: 'https://mc.bajajfinserv.in/media/catalog/product/i/n/innova_hycross_g-flt_7s_p_super_white_base_3.jpeg',
        seats: '7+1 Seater',
        fuel: 'Hybrid',
        transmission: 'Automatic'
      }
    ],
    airport: [
      {
        id: 'airport-ertiga',
        name: 'Ertiga (6+1 seats)',
        models: 'Innova, Ertiga',
        type: 'Family',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: '1,599',
        priceLabel: 'airport transfer',
        includes: 'Airport pickup/drop',
        image: ertigaImage,
        seats: '6+1 Seater',
        bags: 4,
        fuel: 'Petrol/Diesel',
        transmission: 'Manual',
        rating: 4.7,
        features: ['Extra Luggage', 'Family Comfort', 'Premium Service']
      },
      {
        id: 'airport-kia-carens',
        name: 'Kia Carens (6+1 seats)',
        models: 'Kia Carens',
        type: 'Family',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: '1,699',
        priceLabel: 'airport transfer',
        includes: 'Airport pickup/drop',
        image: kiaCarensImage,
        seats: '6+1 Seater',
        bags: 5,
        fuel: 'Petrol/Diesel',
        transmission: 'Manual',
        rating: 4.7,
        features: ['Extra Luggage', 'Family Comfort', 'Premium Service']
      },
      {
        id: 'airport-crysta',
        name: 'Innova Crysta (7+1 seats)',
        models: 'Toyota Innova Crysta',
        type: 'Premium Family',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: '1,999',
        priceLabel: 'airport transfer',
        includes: 'Airport pickup/drop',
        image: crystaImage,
        seats: '7+1 Seater',
        bags: 5,
        fuel: 'Diesel',
        transmission: 'Manual',
        rating: 4.8,
        features: ['Luxury Interior', 'Captain Seats', 'Premium AC']
      },
      {
        id: 'airport-hycross',
        name: 'Innova Hycross (7+1 seats)',
        models: 'Toyota Innova Hycross',
        type: 'Premium Family',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: '2,299',
        priceLabel: 'airport transfer',
        includes: 'Airport pickup/drop',
        image: hycrossImage,
        seats: '7+1 Seater',
        bags: 5,
        fuel: 'Hybrid',
        transmission: 'Automatic',
        rating: 4.8,
        features: ['Luxury Interior', 'Captain Seats', 'Premium AC']
      },
      {
        id: 'airport-fortuner',
        name: 'Fortuner (7+1 seats)',
        models: 'Toyota Fortuner',
        type: 'Premium SUV',
        icon: <FaCar className="text-yellow-500 text-2xl" />,
        price: '4,000',
        priceLabel: 'airport transfer',
        includes: 'Airport pickup/drop',
        image: fortunerImage,
        seats: '7+1 Seater',
        bags: 5,
        fuel: 'Diesel',
        transmission: 'Automatic',
        rating: 4.8,
        features: ['Luxury Interior', 'Captain Seats', 'Premium AC']
      }
    ]
  };

  useEffect(() => {
    let isMounted = true;

    const loadVehicles = async () => {
      try {
        setIsLoadingApiVehicles(true);
        const nextVehicles = await loadLandingPageVehicles('suv', suvImageMap);
        if (isMounted) setApiSuvList(nextVehicles);
      } catch (error) {
        if (isMounted) setApiSuvList({ airport: [], outstation: [], local: [] });
      } finally {
        if (isMounted) setIsLoadingApiVehicles(false);
      }
    };

    loadVehicles();

    return () => {
      isMounted = false;
    };
  }, []);

  const currentData = apiSuvList[activeTab]?.length ? apiSuvList[activeTab] : (suvList[activeTab] || suvList.local);
  const activeTabNote = {
    airport: 'Airport transfer fares. Toll and parking extra as per actuals.',
    local: 'Local packages: 8h/80km included. Toll and parking extra as per actuals.',
    outstation: 'Outstation: 300km/day included. Driver bata + toll/parking extra',
  }[activeTab];

  const handleBookNow = (suv) => {
    const apiBookingState = buildLandingBookingState(suv, activeTab);
    if (apiBookingState) {
      navigate('/booking', { state: apiBookingState });
      return;
    }

    const isLocal = activeTab === 'local';
    const isAirport = activeTab === 'airport';
    const tabLabel = isAirport ? 'Airport transfer' : isLocal ? 'local package' : 'outstation package';
    const vehicleData = {
      id: suv.id,
      name: suv.name,
      type: 'SUV',
      category: 'SUV',
      seats: suv.seats,
      fuel: suv.fuel,
      transmission: suv.transmission,
      image: suv.image,
      price: isLocal ? suv.price : suv.price,
      priceLabel: suv.priceLabel,
      includes: suv.includes,
      bags: suv.bags,
      models: suv.models,
      features: suv.features,
      extraKm: suv.extraKm,
      extraHour: suv.extraHour,
      driverBeta: suv.driverBeta,
      minKms: suv.minKms,
    };
    const bookingData = {
      vehicle: vehicleData,
      route: {
        routeName: `${suv.name} ${tabLabel}`,
        pickup: '',
        dropoff: '',
        distance: isLocal ? 80 : isAirport ? 40 : suv.minKms,
        estimatedTime: isLocal ? '8 hours' : isAirport ? 'Airport transfer' : '',
        price: suv.price,
        tripDirection: isLocal ? 'Local' : isAirport ? 'Airport Transfer' : 'Outstation',
        tripType: activeTab,
      },
      pricing: isLocal
        ? {
            basePrice: suv.price,
            includedKms: 80,
            includedHours: 8,
            extraPerKm: suv.extraKm,
            extraPerHour: suv.extraHour,
          }
        : isAirport
        ? {
            basePrice: suv.price,
            includedKms: 40,
            tolls: 'Extra as per actuals',
            parking: 'Extra as per actuals',
          }
        : {
            basePrice: suv.price,
            pricePerKm: suv.price,
            driverBata: suv.driverBeta,
            minKms: suv.minKms,
          },
    };

    navigate('/booking', {
      state: {
        selectedVehicleData: vehicleData,
        initialRouteData: bookingData,
        tripType: isLocal ? 'Local Taxi' : isAirport ? 'Airport Taxi' : 'Outstation',
      },
    });
  };

  return (
    <div className="min-h-screen bg-white text-black font-sans">
      {/* Hero / Header Section */}
      <div className="relative bg-gradient-to-r from-white via-white to-yellow-50 border-b border-yellow-100">
        <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
          <div className="text-center md:text-left md:flex md:justify-between md:items-end">
            <div>
              <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
                <FaCar className="text-yellow-600" />
                <span>Premium SUV Rentals</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">
                Drive <span className="text-yellow-600">Your Style</span>
                <br />
                Choose Your SUV
              </h1>
              <p className="text-gray-600 mt-3 max-w-lg">
                Comfortable, spacious & reliable SUVs for local city rides or long outstation trips. 
                Transparent pricing, zero hidden charges.
              </p>
            </div>
            {/* <div className="flex gap-3 mt-6 md:mt-0">
              <button className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-xl font-semibold transition shadow-md">
                <FaWhatsapp size={18} />
                <span>WhatsApp</span>
              </button>
              <button className="flex items-center gap-2 border-2 border-yellow-500 text-yellow-700 hover:bg-yellow-50 px-5 py-2.5 rounded-xl font-semibold transition">
                <FaPhoneAlt size={14} />
                <span>Call Now</span>
              </button>
            </div> */}
          </div>
        </div>
      </div>

      {/* Tab Switcher */}
      <div className="max-w-7xl mx-auto px-4 mt-6 mb-2">
        <div className="flex flex-wrap gap-3 border-b border-gray-200 pb-2">

          <button
            onClick={() => setActiveTab('airport')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-t-xl font-bold text-base transition-all ${
              activeTab === 'airport'
                ? 'bg-yellow-500 text-white shadow-md -mb-[2px] border-b-2 border-yellow-600'
                : 'bg-gray-100 text-gray-700 hover:bg-yellow-100'
            }`}
          >
            <FaPlane className="text-sm" />
            AIRPORT TRANSFER
          </button>
          <button
            onClick={() => setActiveTab('outstation')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-t-xl font-bold text-base transition-all ${
              activeTab === 'outstation'
                ? 'bg-yellow-500 text-white shadow-md -mb-[2px] border-b-2 border-yellow-600'
                : 'bg-gray-100 text-gray-700 hover:bg-yellow-100'
            }`}
          >
            <FaRoad className="text-sm" />
            OUTSTATION
          </button>
          <button
            onClick={() => setActiveTab('local')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-t-xl font-bold text-base transition-all ${
              activeTab === 'local'
                ? 'bg-yellow-500 text-white shadow-md -mb-[2px] border-b-2 border-yellow-600'
                : 'bg-gray-100 text-gray-700 hover:bg-yellow-100'
            }`}
          >
            <FaRoad className="text-sm" />
            LOCAL / ROUND TRIP
          </button>
         
        </div>
        <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
          <span className="inline-block w-1.5 h-1.5 bg-yellow-500 rounded-full"></span>
          {activeTabNote}
        </p>
      </div>

      {/* SUV Cards Grid */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        {isLoadingApiVehicles && (
          <div className="mb-4 rounded-xl bg-yellow-50 px-4 py-3 text-sm font-semibold text-yellow-800">
            Loading latest SUV rates...
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {currentData.map((suv) => (
            <div
              key={suv.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              {/* Image Container */}
              <div className="relative h-48 bg-gradient-to-br from-gray-50 to-yellow-50 overflow-hidden">
                <img
                  src={suv.image}
                  alt={suv.name}
                  className="w-full h-full object-cover transition duration-500 hover:scale-105"
                  onError={(e) => {
                    e.currentTarget.src = 'https://via.placeholder.com/400x250?text=SUV+Image';
                  }}
                />
                <div className="absolute top-3 left-3 bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-2 py-1 rounded-lg flex items-center gap-1">
                  <GiCarSeat size={12} />
                  <span>{suv.seats}</span>
                </div>
                <div className="absolute top-3 right-3 bg-yellow-500 text-black font-extrabold text-xs px-2.5 py-1 rounded-full shadow-md">
                  {activeTab === 'airport' ? 'Airport Transfer' : activeTab === 'local' ? 'Best for City' : 'Long Drive'}
                </div>
              </div>

              {/* Content */}
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-xl font-extrabold text-gray-900 tracking-tight">{suv.name}</h3>
                  <div className="bg-yellow-100 p-1.5 rounded-full">{suv.icon}</div>
                </div>

                {/* Specs row */}
                <div className="flex flex-wrap gap-3 text-xs text-gray-600 mb-4 border-b border-gray-100 pb-3">
                  <div className="flex items-center gap-1">
                    <MdLocalGasStation className="text-yellow-600" />
                    <span>{suv.fuel}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <GiGearStick className="text-yellow-600" />
                    <span>{suv.transmission}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <FaCar className="text-yellow-600 text-xs" />
                    <span>AC</span>
                  </div>
                </div>

                {/* PRICE Section with big emphasis */}
                <div className="mb-4">
                  <div className="flex items-baseline gap-1 flex-wrap">
                    <span className="text-2xl font-black text-yellow-600">
                      <FaRupeeSign className="inline text-xl mr-0.5" />
                      {suv.price}
                    </span>
                    <span className="text-gray-500 text-sm font-medium">/ {suv.priceLabel}</span>
                  </div>
                  <p className="text-sm font-semibold text-gray-800 mt-1 bg-yellow-50 inline-block px-2 py-0.5 rounded-md">
                    {suv.includes}
                  </p>
                </div>

                {/* Extra details based on local / outstation */}
                {activeTab === 'local' ? (
                  <div className="space-y-2 text-sm bg-gray-50 p-3 rounded-xl">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Extra km:</span>
                      <span className="font-bold text-black">
                        <FaRupeeSign className="inline text-xs" /> {suv.extraKm}/km
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Extra hour:</span>
                      <span className="font-bold text-black">
                        <FaRupeeSign className="inline text-xs" /> {suv.extraHour}/hr
                      </span>
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1 mt-1 pt-1 border-t border-gray-200">
                      <FaClock className="text-yellow-500" /> 8h | 80km base package
                    </div>
                    <div className="text-xs text-red-600 bg-red-50 p-1.5 rounded-md mt-1">
                      Toll and parking extra as per actuals.
                    </div>
                  </div>
                ) : activeTab === 'airport' ? (
                  <div className="space-y-2 text-sm bg-gray-50 p-3 rounded-xl">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Transfer fare:</span>
                      <span className="font-bold text-black">
                        <FaRupeeSign className="inline text-xs" /> {suv.price}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Capacity:</span>
                      <span className="font-bold">{suv.seats}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Luggage:</span>
                      <span className="font-bold">{suv.bags} bags</span>
                    </div>
                    <div className="text-xs text-red-600 bg-red-50 p-1.5 rounded-md mt-1">
                      Toll and parking extra as per actuals.
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2 text-sm bg-gray-50 p-3 rounded-xl">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Rate (per km):</span>
                      <span className="font-bold text-black">
                        <FaRupeeSign className="inline text-xs" /> {suv.price}/km
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Min. km / day:</span>
                      <span className="font-bold">{suv.minKms} km</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Driver Bata:</span>
                      <span className="font-bold">
                        <FaRupeeSign className="inline text-xs" /> {suv.driverBeta}/day
                      </span>
                    </div>
                    <div className="text-xs text-red-600 bg-red-50 p-1.5 rounded-md mt-1">
                       Toll, parking & state permit extra (actual)
                    </div>
                  </div>
                )}

                {/* CTA Button */}
                <button
                  onClick={() => handleBookNow(suv)}
                  className="mt-5 w-full bg-yellow-500 hover:bg-yellow-600 text-black font-extrabold py-3 rounded-xl flex items-center justify-center gap-2 transition-all duration-200 shadow-md hover:shadow-lg group"
                >
                  <span>Book Now</span>
                  <FaArrowRight className="group-hover:translate-x-1 transition-transform text-sm" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Additional Info Note: Toll / Parking Disclaimer */}
      <div className="max-w-7xl mx-auto px-4 pb-6">
        <div className="bg-yellow-50 border-l-4 border-yellow-500 rounded-xl p-4 text-sm text-gray-700 flex flex-wrap items-start gap-3">
          <div className="bg-yellow-200 p-2 rounded-full">
            <FaCar className="text-yellow-700" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-black">Important Notes:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 mt-1">
              <li>Airport transfer fares are for pickup/drop bookings. Toll and parking charges are extra as per actuals.</li>
              <li>Local package includes 8 hours / 80 km. Extra km, extra hour, toll, and parking charges are extra.</li>
              <li>Outstation packages include 300 km per day. <span className="font-semibold">Driver bata: â‚¹400-500/day</span> depending on car.</li>
              <li>Toll, parking, interstate permit, and night charges (if applicable) are extra as per actuals.</li>
              <li>All prices are inclusive of GST and driver allowance (except bata for outstation).</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Call Section */}
      {/* <footer className="bg-gray-900 text-white mt-8 py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-4 items-center">
            <div className="bg-yellow-500 p-2 rounded-full">
              <FaPhoneAlt className="text-black" />
            </div>
            <div>
              <p className="text-sm text-gray-300">24/7 Support</p>
              <p className="font-bold text-lg">+91 98765 43210</p>
            </div>
          </div>
          <div className="text-center text-gray-400 text-sm">
            <p>Â© 2025 SUV Cabs â€” Premium SUV Rentals | Transparent Pricing | Clean & Sanitized Cars</p>
          </div>
          <div className="flex gap-3">
            <FaWhatsapp className="text-green-400 text-xl cursor-pointer hover:scale-110 transition" />
            <FaCar className="text-yellow-400 text-xl cursor-pointer hover:scale-110 transition" />
          </div>
        </div>
      </footer> */}
    </div>
  );
};

export default SuvRentalPage;
